import { useState } from 'react';
import type { WatchMessages } from '../useWatchSocket';

export const useIsBatteryStartupSequence = (messages: WatchMessages, hasInitialData: boolean) => {
  const [isBatteryStartupSequence, setIsBatteryStartupSequence] = useState<boolean>();

  // decided once from the first data; later changes to the flags are ignored
  if (hasInitialData && isBatteryStartupSequence === undefined) {
    const fields = messages['components/container_data']?.payload.fields;
    // real alarm or stop is active and valid; startup ones are active but not valid
    setIsBatteryStartupSequence(
      (fields?.is_process_stop_active === true && fields.is_process_stop_valid !== true) ||
        (fields?.is_fire_alarm_active === true && fields.is_fire_alarm_valid !== true)
    );
  }

  return isBatteryStartupSequence ?? false;
};
